import { Button } from "@/components/ui/button";
import { Globe } from "lucide-react";
import { NeuralGlobeLogo } from "@/components/ui/logo";

interface HeaderProps {
  language: 'en' | 'de';
  onLanguageToggle: () => void;
  onRequestQuote: () => void;
}

export const Header = ({ language, onLanguageToggle, onRequestQuote }: HeaderProps) => {
  const content = {
    en: {
      name: "Stefan Kaiser",
      tagline: "Executive Consulting",
      cta: "Get a quote"
    },
    de: {
      name: "Stefan Kaiser",
      tagline: "Executive Consulting",
      cta: "Angebot anfragen"
    }
  };

  const t = content[language];

  return (
    <header className="fixed top-0 left-0 right-0 z-40 bg-background/80 backdrop-blur-md border-b border-border shadow-card">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo/Brand */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg gradient-accent flex items-center justify-center text-accent-foreground shadow-glow">
              <NeuralGlobeLogo className="w-6 h-6" />
            </div>
            <div>
              <div className="font-semibold text-foreground">{t.name}</div>
              <div className="text-xs text-muted-foreground">{t.tagline}</div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="sm"
              onClick={onLanguageToggle}
              className="gap-2"
            >
              <Globe className="h-4 w-4" />
              <span className="hidden sm:inline">{language === 'en' ? 'Deutsch' : 'English'}</span>
              <span className="sm:hidden">{language === 'en' ? 'DE' : 'EN'}</span>
            </Button>
            
            <Button
              variant="hero"
              size="sm"
              onClick={onRequestQuote}
              className="hidden sm:flex"
            >
              {t.cta}
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};